<div class="b-transparent" [class.error]="isInvalidAndDirty(parentFormGroup, dynamicFormControlName)"
     [class.focusInfo]="inputFocus && !isInvalidAndDirty(parentFormGroup, dynamicFormControlName)"
     [formGroup]="parentFormGroup">
    <input class="form-control form-control-sm" type="text" formControlName="{{dynamicFormControlName}}"
           (focus)="onInputFocus()" (blur)="onInputBlurr()">
    <div class="triangle" *ngIf="isInvalidAndDirty(parentFormGroup, dynamicFormControlName)">
        <div class="error-message">
            <ul>
                <li *ngIf="parentFormGroup.hasError('pattern', dynamicFormControlName)">Only numbers are accepted.</li>
            </ul>
        </div>
    </div>
    <div class="triangle" *ngIf="inputFocus && !isInvalidAndDirty(parentFormGroup, dynamicFormControlName)">
        <div class="focusInfo-message">
            <ul>
                <li>Only numbers are accepted.</li>
            </ul>
        </div>
    </div>
</div>
